const profile = {
  id: 1,
  name: "Eve",
  age: 28,
  nickname: "Eviessss",
  height: "5'8\"",
  location: "Los Angeles, CA",
  interests: [
    "Sexting",
    "Intimate photos",
    "Phone sex",
    "Late night chats",
    "Private video calls",
  ],
  lookingFor: "Someone to satisfy my needs",
  favorites: {
    drink: "Anything wet",
    movie: "Fifty Shades of Grey",
    song: "Earned It - The Weeknd",
    food: "Strawberries and chocolate",
  },
  bio: [
    "Hey there... I've been in bed alone all night looking for someone real to talk to. I get so bored and lonely, especially late at night...",
    "I'm looking for someone who wants more than just small talk. I want to show you things I don't show just anyone. Text me and let's see where things go...",
  ],
  exclusiveContent: {
    description: "Unlock exclusive access to Eve's private world.",
    benefits: [
      "24/7 uncensored sexting",
      "Intimate voice calls that get hot",
      "Personalized sexy voice messages",
      "Private photo exchanges",
      "HD video chats that go anywhere",
    ],
    pricing: {
      monthly: "$19.99",
      yearly: "$199.99",
    },
  },
  socialLinks: {
    twitter: "https://twitter.com/erotixai",
    instagram: "https://instagram.com/erotixai",
  },
  preferences: {
    communication: ["Texting", "Voice Calls", "Video Calls"],
    availability: "Evenings and late nights",
  },
  // for gallery part
  mediaItems: [
    { id: 1, date: "Apr 2" },
    { id: 2, date: "Apr 1" },
    { id: 3, date: "Mar 29" },
    { id: 4, date: "Mar 27" },
    { id: 5, date: "Mar 25" },
    { id: 6, date: "Mar 21" },
  ],
};

export default profile;
